import React, { useState } from 'react';

import T from 'Utilities/texts';

import { Content } from 'LegacySBCRA/Content/Content';

import { useBreakpoint } from '../../../../components/misc/Breakpoints/Breakpoints';
import { ReviewsList } from '../../../../components/reviews/ReviewsList/ReviewsList';

import styles from './Reviews.scss';

const Reviews = () => {
  const [failedLoad, setFailedLoad] = useState(false);
  const breakpoints = useBreakpoint();

  return (
    <>
      <Content
        className={styles.view}
        element="section"
        wrapper={{
          className: styles.wrapper,
        }}
      >
        <h1>{T.translate('customerReviewsView.title')}</h1>
        <p>{T.translate('customerReviewsView.intro', { br: breakpoints?.minWidth?.breakpointTabletMobile ? <br /> : '' })}</p>
      </Content>
      <section className={styles.reviews}>
        <ReviewsList failedLoad={failedLoad} setFailedLoad={setFailedLoad} />
        <Content center>
          <a className="mw-link mw-link-blue" href="https://uk.trustpilot.com/review/motorway.co.uk" rel="noopener noreferrer" target="_blank">{T.translate('customerReviewsView.readMoreReviews')}</a>
        </Content>
      </section>
    </>
  );
};

export default Reviews;
